import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

export const withCredentialsInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const clonedRequest = req.clone({
    withCredentials: true,
  });

  return next(clonedRequest);
};
